import { render, staticRenderFns } from "./courseProEs.vue?vue&type=template&id=6e1b27de&scoped=true"
import script from "./courseProEs.vue?vue&type=script&lang=js"
export * from "./courseProEs.vue?vue&type=script&lang=js"
import style0 from "./courseProEs.vue?vue&type=style&index=0&id=6e1b27de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1b27de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e1b27de')) {
      api.createRecord('6e1b27de', component.options)
    } else {
      api.reload('6e1b27de', component.options)
    }
    module.hot.accept("./courseProEs.vue?vue&type=template&id=6e1b27de&scoped=true", function () {
      api.rerender('6e1b27de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/courseDeclare/courseProEs.vue"
export default component.exports